// SEO utility functions
export const setCanonicalURL = (path = '') => {
  const baseURL = 'https://www.mmkind.com.my';
  const canonicalURL = path ? `${baseURL}${path}` : baseURL;
  
  // Remove existing canonical link if any
  const existingCanonical = document.querySelector('link[rel="canonical"]');
  if (existingCanonical) {
    existingCanonical.remove();
  }
  
  // Create new canonical link
  const canonicalLink = document.createElement('link');
  canonicalLink.rel = 'canonical';
  canonicalLink.href = canonicalURL;
  
  // Add to head
  document.head.appendChild(canonicalLink);
  
  return canonicalURL;
};

export const setPageTitle = (title) => {
  document.title = title;
};

export const setMetaDescription = (description) => {
  // Remove existing description meta tag
  const existingDesc = document.querySelector('meta[name="description"]');
  if (existingDesc) {
    existingDesc.remove();
  }
  
  // Create new description meta tag
  const metaDesc = document.createElement('meta');
  metaDesc.name = 'description';
  metaDesc.content = description;
  
  // Add to head
  document.head.appendChild(metaDesc);
};

// Set alternate language links (hreflang)
export const setAlternateTags = (path = '') => {
  const baseURL = 'https://www.mmkind.com.my';
  
  // Remove existing alternate links
  const existingAlternates = document.querySelectorAll('link[rel="alternate"][hreflang]');
  existingAlternates.forEach(link => link.remove());
  
  // Create alternate links for English (default) and Malay
  const englishLink = document.createElement('link');
  englishLink.rel = 'alternate';
  englishLink.hreflang = 'en';
  englishLink.href = path ? `${baseURL}${path}` : baseURL;
  document.head.appendChild(englishLink);
  
  const malayLink = document.createElement('link');
  malayLink.rel = 'alternate';
  malayLink.hreflang = 'ms';
  malayLink.href = path ? `${baseURL}${path}` : baseURL;
  document.head.appendChild(malayLink);
  
  // Add x-default for the default language
  const defaultLink = document.createElement('link');
  defaultLink.rel = 'alternate';
  defaultLink.hreflang = 'x-default';
  defaultLink.href = path ? `${baseURL}${path}` : baseURL;
  document.head.appendChild(defaultLink);
};

// Page-specific SEO data
export const pageSEO = {
  home: {
    title: 'MMK Industries Sdn Bhd - Ipoh Trusted Welding Machines and Hardware Supplier',
    description: 'Founded in 2018, MMK Industries is a trusted supplier and retailer of welding machines and hardware machinery, proudly based in Ipoh, Perak, Malaysia.',
    canonical: '/'
  },
  products: {
    title: 'Products - Welding Machines, Power Tools & Hardware | MMK Industries',
    description: 'Browse our comprehensive range of welding machines, power tools, industrial hardware, and accessories. Quality products from trusted brands.',
    canonical: '/products'
  },
  about: {
    title: 'About Us - MMK Industries Sdn Bhd | Welding & Hardware Supplier',
    description: 'Learn about MMK Industries, your trusted partner for welding machines and hardware supplies in Ipoh, Perak since 2018.',
    canonical: '/about'
  },
  contact: {
    title: 'Contact Us - MMK Industries | Get in Touch',
    description: 'Contact MMK Industries for welding machines, hardware supplies, and repair services. Located in Ipoh, Perak, Malaysia.',
    canonical: '/contact'
  },
  testimonials: {
    title: 'Customer Testimonials - MMK Industries Reviews',
    description: 'Read customer reviews and testimonials for MMK Industries. See why customers trust us for welding machines and hardware supplies.',
    canonical: '/testimonials'
  }
};
